module.exports = __webpack_public_path__ + "img/keyboard-arrow-top-right.1d7582be.svg";